const TEXT = 'View all reviews'
const SPACE = '\xa0'

export const RIGHT_ARROW = '\u1433'
export const BUTTON_DESCRIPTION = TEXT + SPACE.repeat(4)
